export default {
	baseURL: '/',
	monDossier: 'Mon dossier'
}
